import IndexHtml from './IndexHtml'

export default {
  path: '/index.html',
  component: IndexHtml
}



// WEBPACK FOOTER //
// ./src/routes/indexHtml/index.js